import { defineComponent as _defineComponent } from 'vue'
import TabBar from "@/components/TabBar.vue";
import { onMounted, ref, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
import EventBus from "@/uitls/EventBus";
import indexDB from "@/network/db/dexieDb";
import { msg_friend_apply_list } from "@/network/socket/SocketReq";
import { getIMListAll, syncIMListRedWithUnread } from "@/network/db/dbServe";
import { YMPush } from "@/uitls/uitls";
import Platform from "@/config/platform";
import Storage from "@/uitls/Storage";

import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'index',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()

const piniaStore = serverConfigPiniaState();
const { offChat } = storeToRefs(piniaStore);
const { getConfig } = piniaStore;


onMounted(() => {
  getConfig();
  getMsgList();
  msg_friend_apply_list()
  YMPush('MAIN', '主界面')
});

onUnmounted(() => {
  EventBus.off("newFriendNum1")
  EventBus.off("newFriend")
  EventBus.off("layoutRed")
})


EventBus.on("newFriendNum1", (num: number) => {
  // console.log("newFriendNum",num);

  let msgIndex = 3;
  tabBar.value.forEach((item, index) => {
    if (item.title == t('home.Friend')) {
      // item.redNum = redNum.value
      msgIndex = index
    }
  })
  tabBar.value[msgIndex].redNum = num > 0 ? num + "" : ""
});
EventBus.on("newFriend", (list: Array<any>) => {
  // badge.value  = list.length
  let tempList = [];
  list.forEach(item => {
    // console.log(item);

    if (item.applyState == 0) {
      tempList.push(item)
    }
  })
  let msgIndex = 3;
  tabBar.value.forEach((item, index) => {
    if (item.title == t('home.Friend')) {
      // item.redNum = redNum.value
      msgIndex = index
    }
  })
  tabBar.value[msgIndex].redNum = tempList.length > 0 ? tempList.length + "" : ""

});

const standalone = Platform.standalone;
const homeTab = {
  title: t('home.Home'),
  to: {
    name: "Home",
  },
  icon: {
    active: require(`@/assets/${process.env.VUE_APP_NAME}/home_sel.png`),
    inactive: require(`@/assets/${process.env.VUE_APP_NAME}/home.png`),
    height: '28px',
  },
  redNum: ""
};

const matchTab = {
  title: t('home.Match'),
  to: {
    name: "Match",
  },
  icon: {
    active: require(`@/assets/${process.env.VUE_APP_NAME}/match_sel.png`),
    inactive: require(`@/assets/${process.env.VUE_APP_NAME}/match.png`),
  },
  redNum: ""
};

const msgTab = {
  title: t('home.Message'),
  to: {
    name: "Message",
  },
  icon: {
    active: require(`@/assets/${process.env.VUE_APP_NAME}/msg_sel.png`),
    inactive: require(`@/assets/${process.env.VUE_APP_NAME}/msg.png`),
  },
  redNum: ""
};

const friendTab = {
  title: t('home.Friend'),
  to: {
    name: "Friend",
  },
  icon: {
    active: require(`@/assets/${process.env.VUE_APP_NAME}/friend_sel.png`),
    inactive: require(`@/assets/${process.env.VUE_APP_NAME}/friend.png`),
  },
  redNum: ""
};

const meTab = {
  title: t('home.Me'),
  to: {
    name: "Me",
  },
  icon: {
    active: require(`@/assets/${process.env.VUE_APP_NAME}/my_sel.png`),
    inactive: require(`@/assets/${process.env.VUE_APP_NAME}/my.png`),
  },
  redNum: ""
};


const tabBar = process.env.VUE_APP_NAME == "yn" ? ref([matchTab, friendTab, homeTab, msgTab, meTab]) : ref([homeTab,matchTab, msgTab, friendTab, meTab])

const offchatBar = ref([
  homeTab,
  matchTab,
  meTab,
],
)

EventBus.on("layoutRed", () => {
  getMsgList();
});
EventBus.on("dbOnsuccess", () => {
  getMsgList();
});

const redNum = ref(0);
const getMsgList = async () => {

  if (!indexDB.open) {
    return;
  }
  const v = await getIMListAll();
  const myUid = Storage.get('uid');
  await Promise.all(v.map(async (item: any) => {
    if (!item.chatkey) {
      return;
    }
    item.red = await syncIMListRedWithUnread(item.chatkey, myUid);
  }));
  redNum.value = 0;
  v.forEach((item: any) => {
    redNum.value = item.red + redNum.value;
  });
  let msgIndex = 2;
  tabBar.value.forEach((item, index) => {
    if (item.title == t('home.Message')) {
      msgIndex = index
    }
  })
  tabBar.value[msgIndex].redNum = redNum.value > 0 ? redNum.value + "" : ""
};


const __returned__ = { t, piniaStore, offChat, getConfig, standalone, homeTab, matchTab, msgTab, friendTab, meTab, tabBar, offchatBar, redNum, getMsgList, TabBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})